import { useQuery } from '@tanstack/vue-query'
import { FIVE_MINUTES_MS } from '@shared/utils'
import { notificationKeys } from './notificationQueryKeys'
import type { Notification } from '../types/notificationTypes'

export function useNotificationsQuery() {
  return useQuery<Notification[]>({
    queryKey: notificationKeys.list(),
    queryFn: () => Promise.resolve([]),
    staleTime: FIVE_MINUTES_MS,
  })
}
